export default __webpack_public_path__ + "static/media/logoCropped.82983d7f.png";